import { createRoot } from '@wordpress/element';
import App from '@/App';

const root = createRoot( document.getElementById( 'getting-started-page' ) );
root.render( <App /> );
